import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./bannerStyle.css";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import Slider from "react-slick";
import { Box, Image, Icon } from "@chakra-ui/react";
import { Link } from "react-router-dom";

function FinalBanner() {
  const PreviousArrow = ({ onClick }) => (
    <Box
      position="absolute"
      left={{ base: "8px", md: "16px" }}
      top="50%"
      transform="translateY(-50%)"
      zIndex="2"
      w={{ base: "34px", md: "44px" }}
      h={{ base: "34px", md: "44px" }}
      bg="rgba(15, 23, 42, 0.6)"
      backdropFilter="blur(6px)"
      color="white"
      rounded="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      transition="all 0.2s"
      _hover={{ bg: "rgba(15, 23, 42, 0.85)", transform: "translateY(-50%) scale(1.08)" }}
      shadow="0 4px 12px rgba(0,0,0,0.3)"
      onClick={onClick}
      role="button"
      aria-label="Previous Slide"
    >
      <Icon as={FiChevronLeft} boxSize={{ base: "18px", md: "24px" }} />
    </Box>
  );

  const NextArrow = ({ onClick }) => (
    <Box
      position="absolute"
      right={{ base: "8px", md: "16px" }}
      top="50%"
      transform="translateY(-50%)"
      zIndex="2"
      w={{ base: "34px", md: "44px" }}
      h={{ base: "34px", md: "44px" }}
      bg="rgba(15, 23, 42, 0.6)"
      backdropFilter="blur(6px)"
      color="white"
      rounded="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      transition="all 0.2s"
      _hover={{ bg: "rgba(15, 23, 42, 0.85)", transform: "translateY(-50%) scale(1.08)" }}
      shadow="0 4px 12px rgba(0,0,0,0.3)"
      onClick={onClick}
      role="button"
      aria-label="Next Slide"
    >
      <Icon as={FiChevronRight} boxSize={{ base: "18px", md: "24px" }} />
    </Box>
  );

  const settings = {
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3800,
    pauseOnHover: true,
    prevArrow: <PreviousArrow />,
    nextArrow: <NextArrow />,
    dots: true,
    fade: true,
  };

  const slides = [
    { src: "./slider/s1.jpeg", alt: "Supreme Today AI", link: "/supremeAi" },
    { src: "./slider/s2.jpeg", alt: "Law Books Collection", link: "/products/cids=1" },
    { src: "./slider/s3.jpeg", alt: "Lawyers Clothing & Accessories", link: "/products?maincat=Cloths-Accessories" },
    { src: "./slider/s4.jpeg", alt: "Legal Research Assistance", link: "/leagleReaserch" },
    { src: "./slider/s5.jpeg", alt: "Judgments & Bare Acts", link: "/products/productsByCid?cid=15" },
    { src: "./slider/s6.jpeg", alt: "Legal Software Solutions", link: "/software" },
    { src: "./slider/s7.jpeg", alt: "Litigation Management Software", link: "/lms" },
    { src: "./slider/s8.jpeg", alt: "Dictation & Translation Software", link: "/dandt" },
  ];

  return (
    <Box maxW="1360px" mx="auto" px={{ base: "2", md: "4", lg: "6" }} py={{ base: "2", md: "4" }}>
      <Box
        rounded={{ base: "xl", md: "2xl" }}
        overflow="hidden"
        shadow="0 8px 24px -4px rgba(15, 23, 42, 0.12)"
        position="relative"
        bg="#0F172A"
      >
        <Slider {...settings}>
          {slides.map((slide, idx) => (
            <Link key={idx} to={slide.link}>
              <Box position="relative" cursor="pointer">
                <Image
                  src={slide.src}
                  alt={slide.alt}
                  w="100%"
                  h={{ base: "160px", sm: "220px", md: "290px", lg: "340px" }}
                  objectFit="cover"
                  loading={idx === 0 ? "eager" : "lazy"}
                  transition="transform 0.4s ease"
                  _hover={{ transform: "scale(1.01)" }}
                />
              </Box>
            </Link>
          ))}
        </Slider>
      </Box>
    </Box>
  );
}

export default FinalBanner;
